import { render, staticRenderFns } from "./TsGoWelfare.vue?vue&type=template&id=2af66e9a&scoped=true"
import script from "./TsGoWelfare.vue?vue&type=script&lang=js"
export * from "./TsGoWelfare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af66e9a",
  null
  
)

export default component.exports